// @flow

// Modules
import React from 'react';
import { render } from 'react-dom';
import styled, { createGlobalStyle } from 'styled-components';

// Methods
import Api from 'src/methods/api';
import { getApiUrl } from 'src/methods/network/url';

// Container
import Home from 'containers/home';
import type { PropTypes } from 'containers/home';
import ErrorBoundary from 'src/containers/errorboundary';

// Styles
import baseStyle from 'src/styles/basestyle';
import scrollbar from 'src/styles/scrollbar';

// Assets
import FontsStyle from 'assets/fonts';

/**
 * Styles
 */

// On initialise les styles globaux (Dev only)
const GlobalStyle = createGlobalStyle`
  ${baseStyle}
  ${scrollbar}
`;

const ChallengeRoot = styled.div`
  ${baseStyle}
  ${scrollbar}
`;

/**
 * Component for library export
 */

const Challenges = (props: PropTypes): React$Element<typeof ErrorBoundary> => {
  const { env, applicationName, operator } = props;
  const apiUrl = getApiUrl(env, operator);

  // Initialize api for catching warn/error
  Api.configure(apiUrl, applicationName, operator);

  return (
    <ErrorBoundary name={'Challenges'}>
      <FontsStyle />
      <ChallengeRoot>
        <Home {...props} />
      </ChallengeRoot>
    </ErrorBoundary>
  );
};

if (__BUILD_TARGET__ === 'web' && __BUILD_MODE__ !== 'development') {
  render(<Challenges {...window.config} />, document.getElementById('root'));
}

/**
 * DEV
 */
if (__BUILD_TARGET__ === 'web' && __BUILD_MODE__ === 'development') {
  // Fake props
  const DEV_PROPS: PropTypes = {
    applicationName: 'testDev',
    language: 'fr_FR',
    operator: 'wam',
    env: 'prod',
    isMobile: false,
    hidePlayerInfo: false,
    headerMemo: { selectedChallenge: 0, selectedType: 0, selectedDate: 0 },
    headerParams: { challenge: 'cashgame', limit: 'high', date: '14-06-2022', ts: Date.now() },
    navigate: (action: string) => console.error(action)
  };

  // Initialize api for catching warn/error
  const apiUrl = getApiUrl(DEV_PROPS.env, DEV_PROPS.operator);
  Api.configure(apiUrl, 'testing', DEV_PROPS.operator);

  const renderScene = function (container: any, GlobalStyle: any): Promise<AnyFunction> {
    return new Promise((resolve) => {
      const renderContainer = (Component: any) => {
        render(
          <ErrorBoundary name={'Challenges'}>
            <FontsStyle />
            {GlobalStyle && <GlobalStyle />}
            <Component {...DEV_PROPS} />
          </ErrorBoundary>,
          window.document.getElementById('root')
        );
      };
      renderContainer(container);
      resolve(renderContainer);
    });
  };

  /**
   * Dev renderer et Hot-reload
   */

  renderScene(Home, GlobalStyle).then((render) => {
    document.title = 'Challenges';

    // On configure le hot reloading ($FlowFixMe)
    // $FlowFixMe
    if (module.hot) {
      (module.hot: any).accept('./containers/home.js', () => {
        const container = require('./containers/home.js').default;

        render(container);
      });
    }
  });
}

export default Challenges;
